// Native focus may leave a partly visible card clipped inside a horizontal gallery.
document.addEventListener('focusin', (event) => {
  const link = event.target.closest?.('.sg-portfolio__image-link');
  const gallery = link?.closest('.sg-portfolio__gallery');
  if (!gallery || gallery.scrollWidth <= gallery.clientWidth) return;
  link.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
});
